import { Component, OnInit, Input } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';

import { DataService } from '../../providers/data.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  providers: [ConfirmationService]
})
export class OrdersComponent implements OnInit {

  @Input() mode: string = 'new';

  now: string = new Date().toISOString();
  show_popup = false;
  show_order_type = 'order';
  // show_leads = false;
  // show_orders = true;
  new_order_count = 0;
  new_lead_count  = 0;

  display_confirm_dialog: boolean = false;
  loading: boolean;
  last_fetch: Date;
  headers: any;

  base_headers: any[] = [
    { title: 'date', sort_field: 'created',  class: 'th--small', with: '7em'},

    { title: 'order# / email', sort_field: 'id', class: 'th--normal', with: '16em' },
    { title: 'client', sort_field: 'parent.id', class: 'th--small', with: '20em' },

    { title: 'items', class: 'th--normal' },
    { title: 'amount', sort_field: 'total_price', class: 'th--normal', with: '7em' },

    { title: 'status', sort_field: 'status', class: 'th--small', with: '12em' },
  ];

  order_list: any;
  current_order: any;
  confirmation_message: string;
  target_status: string;

  constructor(private dataService: DataService, private route: ActivatedRoute, private confirmService: ConfirmationService) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      if(!!params['mode']) this.mode = params.mode;
      this.headers = [...this.base_headers];
      if(this.mode == 'new'){
        this.headers.push(
          { title: '', class: 'th--edit', with: '3em' })
      }
      // if(this.mode == 'new'){
      //   this.listen_to_orders();
      // } else {
      //   this.getOrders();
      // }
      this.getOrders();
    });
  }

  _update_counts(){
    this.new_lead_count = this.new_order_count = 0;
      for( let order of this.order_list ){
        if( order.status.indexOf('LEAD') < 0 ){
          this.new_order_count += 1;
        } else {
          this.new_lead_count += 1;
        }
      }
  }

  getOrders(refresh: boolean = false) {
    this.loading = true;
    this.dataService.getOrders(this.mode, refresh).subscribe(result =>{
        this.loading = false;
        this.last_fetch = new Date();
        this.order_list = result;
        this._update_counts();
      },
      (err) => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  listen_to_orders(){
    this.dataService.listen_to_new_orders(5*60 ).subscribe(result =>{
        this.loading = false;
        this.last_fetch = new Date();
        this.order_list = result;
        this._update_counts();
      },
      (err) => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  open_confirmation_page(order){
    let url = order.sub_user.order_confirmation_link;
    url = url.replace('__ORDERID__', order.id);
    url += '/' + order.sub_user.password.replace('$sha1$', '/');
    window.open(url, "_blank");
  }

  editOrder(order, new_status) {
    let future_order = {...order};
    order.processing = true;
    future_order.status = 'REQUEST ' + new_status;
    this.dataService.put('order', future_order).subscribe(new_order => {
       if( new_status != "ADD_COMMENT") {
          order.status = new_order['status'];
          order.updated_by = new_order['updated_by'];
       }
       order.admin_remarks = new_order['admin_remarks'];
       order.is_mine = order.updated_by == this.dataService.current_user_name;
       delete order.processing;
       delete order.add_remark; // prevent double submits
    }, err=>{
      order.status = 'ERROR';
      delete order.processing;
    });
  }

  editParent(user, new_status) {
    user.status = 'REQUEST ' + new_status;
    this.dataService.put('user', user).subscribe(new_user => {
       user.status = new_user['status'];
       user.updated_by = new_user['updated_by'];
       user.is_mine = user.updated_by == this.dataService.current_user_name;
    }, err=>{
      user.status = 'ERROR';
    });
  }

  show_order_row(order){
    if(this.mode !== 'new') return true;
    if( this.show_order_type == 'confirmed lead' && order.status.indexOf('CONFIRMED_LEAD') == 0) return true;
    if( this.show_order_type == 'lead' && order.status.indexOf('LEAD') == 0) return true;
    if( this.show_order_type == 'order' && order.status.indexOf('LEAD') < 0) return true;
    return false;
  }

  show_comment_dialog(order){
    this.target_status = 'ADD_COMMENT';
    this.current_order = order;
    this.confirmation_message = "Add a comment to this order";
    this.display_confirm_dialog = true;
  }

  confirm_cancel(order){
    this.target_status = 'CANCELED';
    this.current_order = order;
    this.confirmation_message = "Are you sure you want to cancel this order?";
    this.display_confirm_dialog = true;

    // this.confirmService.confirm({
    //     message: "Are you sure you want to cancel this order?",
    //     accept: (remark) => {
    //       order.add_remark = remark;
    //       this.editOrder(order, 'CANCELED');
    //     }
    // });
  }

  handle_confirmation(order, confirmed){
    if( confirmed ){
      this.editOrder(order, this.target_status);
      this.target_status = null;
    }
    this.display_confirm_dialog = false;
  }

  populate_empty_mail(order){
    if( !order.change_email ){
      order.change_email = order.sub_user.email;
    }
  }
  // createOrder() {
  //   this.show_popup = true;
  // }

  // onClose(event) {
  //   this.order = undefined;
  //   this.show_popup = false;
  // }

  onNotify(event) {
    // this.presentOrder(event.type, event.title, event.body);
  }

  // presentOrder(type: string, title: string, body: string) {
  //   this.orderService.add({severity: type, summary: title, detail: body});
  // }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/orders/orders.component.ts